import { AbsenceItemType } from './types';
import { Status } from '../../../../../atomic/atoms/StatusIcon/StatusIcon';
import {
  Dashboard_UpcomingAbsencesFragment,
  AbsenceType,
} from '../../../__generated__/graphql';

export const mapUpcomingAbsence = (
  absence: Dashboard_UpcomingAbsencesFragment,
): AbsenceItemType => {
  const isHourly = absence.flair__Type__c === AbsenceType.Hourly;
  const isMultiDay =
    absence.flair__Start_Date__c !== absence.flair__End_Date__c;

  return {
    id: absence.Id,
    status: absence.flair__Approval_Status__c as Status,
    startDateTime: `${absence.flair__Start_Date__c} ${absence.flair__Start_Time__c}`,
    endDateTime: `${absence.flair__End_Date__c} ${absence.flair__End_Time__c}`,
    categoryIcon: absence.flair__Category_Icon__c,
    categoryName: absence.flair__Category_Name__c,
    type: absence.flair__Type__c,
    withdrawalAmount: absence.flair__Withdrawal_Amount__c,
    commentsCount: absence.commentsCount,
    isHourly,
    isMultiDay,
  };
};
